module.exports = __webpack_public_path__ + "img/brands-pan-river.jpg?920a507e52657822f110308b95b2b99d";